import { render, staticRenderFns } from "./widgetTime.vue?vue&type=template&id=28f96bdb&scoped=true&"
import script from "./widgetTime.vue?vue&type=script&lang=js&"
export * from "./widgetTime.vue?vue&type=script&lang=js&"
import style0 from "./widgetTime.vue?vue&type=style&index=0&id=28f96bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f96bdb",
  null
  
)

export default component.exports